import { Navigate } from "react-router-dom";
import { getPermissions } from "context/AuthContext";

const ProtectedRoute = ({ permission, children }) => {
  const permissions = getPermissions();

  if (permission && !permissions.includes(permission)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
